export default "__VITE_ASSET__CDVVDXES__"